module.exports = __webpack_public_path__ + "img/ssb_menu9.9b93c2de.png";